import { RouteKeys } from "@/api_framework/api_modals/Routers";
import { useAppSelector } from "@/app_redux/hooks/root_hook";
import { useEffect, useState } from "react";

export const useRBACFlag = (actionId?: RouteKeys) => {
  const [actions, setActions] = useState<Array<string>>([]);
  const userPermissions = useAppSelector((state) => state?.auth?.userPermissions);

  useEffect(() => {
    if (!actionId) return;
    if (userPermissions?.role_permission && userPermissions?.role_permission?.actions?.length > 0) {
      setActions(userPermissions?.role_permission?.actions);
    } else {
      setActions([]);
    }
  }, [userPermissions]);

  return {
    status: actionId
      ? actions?.length === 0
        ? true
        : actions.length > 0 && actions.includes(actionId)
          ? true
          : false
      : false,
  };
};
